import moment from "moment/moment";
import { DisconnectionContactDetails } from "../../../../types/DisconnectionContactDetails";
import { DisconnectionPropertyDetails } from "../../../../types/DisconnectionPropertyDetails";

export const SAME_AS_REQUESTER = "requester";
export const SAME_AS_SITE_CONTACT = "site-access-contact";
export const SAME_AS_PROPERTY_OWNER = "property-owner-contact";
export const SAME_AS_NEW_CONTACT = "new-contact";

export const withNaCheck = (input: string) => {
  return input ? input : "N/A";
};

export const mapAccessIssuesForDisplay = (
  guardDogs: boolean,
  lockedGate: boolean,
): string => {
  const guardDogName = guardDogs ? "Guard dog(s)" : "";
  const lockedGateName = lockedGate ? "Locked gates" : "";
  return withNaCheck(
    [guardDogName, lockedGateName].filter((str) => str).join(", "),
  );
};

export const mapAccessIssues = (
  values: DisconnectionPropertyDetails,
): string => {
  return mapAccessIssuesForDisplay(values.guardDogs, values.lockedGate);
};

export const formatDateForDisplay = (input: string) => {
  return input ? moment(input, "YYYY-MM-DD").format("DD/MM/YYYY") : input;
};

export const isSiteContactAlso = (
  sameAsRole: string,
  contactDetails: DisconnectionContactDetails,
): boolean => {
  return contactDetails.siteContactSameAsRole === sameAsRole;
};

export const isPropertyOwnerAlso = (
  sameAsRole: string,
  contactDetails: DisconnectionContactDetails,
): boolean => {
  return contactDetails.propertyOwnerSameAsRole === sameAsRole;
};

export const isRequesterAlsoTheSiteContact = (
  contactDetails: DisconnectionContactDetails,
): boolean => {
  return (
    // site contact -> requester
    isSiteContactAlso(SAME_AS_REQUESTER, contactDetails) ||
    // site contact -> property owner -> requester
    (isSiteContactAlso(SAME_AS_PROPERTY_OWNER, contactDetails) &&
      isPropertyOwnerAlso(SAME_AS_REQUESTER, contactDetails))
  );
};

export const isRequesterAlsoThePropertyOwner = (
  contactDetails: DisconnectionContactDetails,
): boolean => {
  return (
    // property owner -> requester
    isPropertyOwnerAlso(SAME_AS_REQUESTER, contactDetails) ||
    // property owner -> site contact -> requester
    (isPropertyOwnerAlso(SAME_AS_SITE_CONTACT, contactDetails) &&
      isSiteContactAlso(SAME_AS_REQUESTER, contactDetails))
  );
};

export const mapRequestHeader = (
  contactDetails: DisconnectionContactDetails,
): string => {
  const propertyOwnerSameAsRole = isRequesterAlsoThePropertyOwner(
    contactDetails,
  )
    ? "Property owner"
    : "";
  const siteContactSameAsRole = isRequesterAlsoTheSiteContact(contactDetails)
    ? "Site contact"
    : "";
  return ["Requester", propertyOwnerSameAsRole, siteContactSameAsRole]
    .filter((str) => str)
    .join(" / ");
};

export const mapPropertyOwnerHeader = (
  contactDetails: DisconnectionContactDetails,
): string => {
  const otherRole =
    SAME_AS_PROPERTY_OWNER === contactDetails.siteContactSameAsRole
      ? "Site contact"
      : "";
  return ["Property owner", otherRole].filter((str) => str).join(" / ");
};

export const mapSiteContactHeader = (
  contactDetails: DisconnectionContactDetails,
): string => {
  const otherRole =
    SAME_AS_SITE_CONTACT === contactDetails.propertyOwnerSameAsRole
      ? "Property owner"
      : "";
  return ["Site contact", otherRole].filter((str) => str).join(" / ");
};
